@if (separatorsCount > 0) {
  <div class="flex relative">
    <ng-container *ngTemplateOutlet="progressBar"></ng-container>
    @for (_ of Array(separatorsCount - 1).fill(0); track index; let index = $index) {
      <div
        class="flex-1 absolute"
        [style]="separatorsCount | exec : separatorStyle : index"
      ></div>
    }
  </div>
} @else {
  <ng-container *ngTemplateOutlet="progressBar"></ng-container>
}

<ng-template #progressBar>
  <p-progressBar
    [mode]="mode"
    [value]="value"
    [showValue]="showValue"
    [ngClass]="{
      grow: separatorsCount > 0,
      rounded: borderStyle === 'rounded',
      squared: borderStyle === 'squared',
    }"
  >
  </p-progressBar>
</ng-template>
